import LedsDiagram from "../../../../docs/_images/hw_ff_leds.png";
import LedsSchematics from "../../../../docs/_images/hw_ff_leds_schem.png";
import * as React from 'react';
export default {
  LedsDiagram,
  LedsSchematics,
  React
};